import React, { useState, useEffect } from "react";
import i18n from "../i18n.js";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import { useForm, Controller } from "react-hook-form";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Alert from "@mui/material/Alert";
import Container from "@mui/material/Container";
import axios from "axios";

// import { FormContainer, TextFieldElement } from "react-hook-form-mui";

const Modify = (props) => {
    // eslint-disable-next-line react/prop-types
    const { itemOptions } = props;
    const { api, comp } = itemOptions;
    const { t } = i18n;
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [entry, setEntry] = useState([]);
    const [email, setEmail] = useState("");
    const [notFound, setNotFound] = useState(false);

    const {
        handleSubmit,
        control,
        watch,
        formState: { errors, isValid },
    } = useForm({
        defaultValues: {
            password: "",
            email: "",
        },
    });
    const onSubmit = (data) => {
        if (isValid || Object.entries(errors).length === 0) {
            setLoading(true);
            setNotFound(false);
            setEntry([]);
            setEmail(data.email);
            axios
                .post(`${api.getEntryForModificationAnonymously}/${comp.id}`, data)
                .then(function (response) {
                   
                    const fetchedEntry = response.data;

                    if (fetchedEntry !== null && Object.keys(fetchedEntry).length !== 0
                    && Object.getPrototypeOf(fetchedEntry) === Object.prototype) {
                        setEntry(fetchedEntry);
                        navigate("/categories", { state: { uuid: fetchedEntry.uuid, entries: fetchedEntry.entries } });

                    } else {
                        setNotFound(true);
                    }

                    setLoading(false);
                })
                .catch(function (error) {
                    setLoading(false);

                    console.log(error);
                });
        } else {
            console.log(errors);
        }
    };
    const onError = (errors, e) => {
        console.log(errors);
    };

    return (
        <React.Fragment>
            <hr />
            <h2 className="display-6 mt-2">{t("reg.modify")}</h2>
            <p>{t("reg.info.modify")}</p>

            <Container maxWidth="xs" className="mb-2">
                <Box>
                    <form onSubmit={handleSubmit(onSubmit, onError)}>
                        <Stack direction="column" spacing={{ xs: 1, sm: 1, md: 4 }}>
                            <Controller
                                name="email"
                                control={control}
                                rules={{
                                    pattern:
                                        /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/,
                                }}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        label={t("email")}
                                        type="email"
                                        required
                                        error={errors.email !== undefined}
                                        helperText={errors.email !== undefined ? t("reg.wdsf.helper.email") : ""}
                                    />
                                )}
                            />
                            <Controller
                                name="password"
                                control={control}
                                render={({ field }) => (
                                    <TextField {...field} label={t("password")} type="password" required error={errors.password !== undefined} />
                                )}
                            />

                            {!loading && (
                                <Button type="submit" variant="outlined">
                                    {t("reg.modify")}
                                </Button>
                            )}
                            {loading && <LinearProgress />}
                        </Stack>
                    </form>
                </Box>
            </Container>

            {notFound && <Alert severity="warning">{t("reg.entry_not_found")}</Alert>}
        </React.Fragment>
    );
};

export default Modify;
